// extracted by extract-css-chunks-webpack-plugin
module.exports = {"tooltipZIndex":"3","tooltipSpacing":"10px","container":"ImOt+Lb6mSAi","active":"QzijzSL3f58b","details":"_4dpXv28lHMJ9"};